<template>
    <!-- 单个骨架组件 -->
    <el-skeleton-item
    ref="skeletonitem"
    :class="className" 
    :variant="variant"/>
</template>
<script>
export default {
    name:"VelSkeletonItem",
    props:{
        className:[String,Array],
        isP:Boolean,
        isH1:Boolean,
        isH3:Boolean,
        isCaption:Boolean,
        isButton:Boolean,
        isImage:Boolean,
        isCircle:Boolean,
        isRect:Boolean,
    },
    data() {
        return {
            variant:''
        };
    },
    created() {
        this.getVariant()
    },
    methods: {
        getVariant(){
            this.isP ? this.variant = 'p' :
            this.isH1 ? this.variant = 'h1' :
            this.isH3 ? this.variant = 'h3' :
            this.isCaption ? this.variant = 'caption' :
            this.isButton ? this.variant = 'button' : 
            this.isImage ? this.variant = 'image' :
            this.isCircle ? this.variant = 'circle' :
            this.isRect ? this.variant = 'rect' : 
            this.variant = 'text' 
        }
    },
}
</script>